var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyCenter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C1.89543 2 1 2.89543 1 4V8.5C1 9.32843 1.67157 10 2.5 10H7H7.5H8H9.5C10.3284 10 11 9.32843 11 8.5V6.5C11 5.39543 10.1046 4.5 9 4.5H8V4C8 2.89543 7.10457 2 6 2H3ZM8 5.5V9H9.5C9.77614 9 10 8.77614 10 8.5V6.5C10 5.94772 9.55228 5.5 9 5.5H8ZM7 4.5V4C7 3.44772 6.55228 3 6 3H3C2.44772 3 2 3.44772 2 4V8.5C2 8.77614 2.22386 9 2.5 9H7V5V4.5Z",
    fill: "#A5A6BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.5C3.5 8.22386 3.72386 8 4 8H5C5.27614 8 5.5 8.22386 5.5 8.5V10H3.5V8.5Z",
    fill: "#A5A6BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4C4.22386 4 4 4.22386 4 4.5V5H3.5C3.22386 5 3 5.22386 3 5.5C3 5.77614 3.22386 6 3.5 6H4V6.5C4 6.77614 4.22386 7 4.5 7C4.77614 7 5 6.77614 5 6.5V6H5.5C5.77614 6 6 5.77614 6 5.5C6 5.22386 5.77614 5 5.5 5L5 5V4.5C5 4.22386 4.77614 4 4.5 4Z",
    fill: "#A5A6BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCenter);
export default __webpack_public_path__ + "static/media/grey-center.1fa1bd8d85e8ce7755305c1d6783cac7.svg";
export { ForwardRef as ReactComponent };